import * as routes from "../data/links/routes";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet, useResolvedPath } from "react-router-dom";

const AdminRoute = () => {
  let { user } = useAuth();
  const { pathname } = useResolvedPath();
  return user.is_admin && pathname === routes.ADMIN ? (
    <Outlet />
  ) : (
    <Navigate to={routes.DASHBOARD} />
  );
};
export default AdminRoute;
